import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useToast } from '@/hooks/use-toast';
import { migrateRelicStorage } from '@/utils/migrate-relic-storage';

const RelicStorageMigrator: React.FC = () => {
  const [bulletinId, setBulletinId] = useState('e5b610c6-f205-4af0-b2ed-9be5b5a20294');
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const handleMigration = async () => {
    if (!bulletinId.trim()) {
      toast({
        title: "Error",
        description: "Please enter a bulletin ID",
        variant: "destructive"
      });
      return;
    }

    setLoading(true);
    try {
      const result = await migrateRelicStorage(bulletinId.trim());
      
      if (result.success) {
        toast({
          title: "Success",
          description: "Relic storage migrated successfully"
        });
        console.log('Migration result:', result.data);
      } else {
        toast({
          title: "Error",
          description: "Failed to migrate relic storage",
          variant: "destructive"
        });
        console.error('Migration error:', result.error);
      }
    } catch (error) {
      console.error('Migration error:', error);
      toast({
        title: "Error",
        description: "An unexpected error occurred",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Relic Storage Migrator</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <label className="text-sm font-medium mb-2 block">Bulletin ID</label>
          <Input
            value={bulletinId}
            onChange={(e) => setBulletinId(e.target.value)}
            placeholder="Enter bulletin ID to migrate storage"
          />
        </div>
        <Button onClick={handleMigration} disabled={loading}>
          {loading ? 'Migrating...' : 'Migrate Storage'}
        </Button>
      </CardContent>
    </Card>
  );
};

export default RelicStorageMigrator;